import axios from '@/libs/api.request';

export const getAreaList = data => {
    return axios.request({
        url: 'api/systemManagement/areaManagement/getAreaList',
        data: data,
        method: 'post'
    });
};

export const saveArea = data => {
    return axios.request({
        url: 'api/systemManagement/areaManagement/saveArea',
        data: data,
        method: 'post'
    });
};
